import PropTypes from "prop-types";
import style from "./SavedSearchButton.module.scss";

const SaveSearchButton = ({
  isBookedMarked = false,
  saveSearchOnClick = () => {},
}) => {
  const iconClass = isBookedMarked ? "tg-icons-SavedFilled" : "tg-icons-Saved";
  return (
    <button
      title="Save search"
      onClick={(e) => saveSearchOnClick(e)}
      className={style.saveSearchButton}
    >
      <i className={iconClass} />
      <span className={style.saveSearchText}>Save search</span>
    </button>
  );
};

SaveSearchButton.propTypes = {
  isBookedMarked: PropTypes.bool,
  saveSearchOnClick: PropTypes.func,
};

export default SaveSearchButton;
